export interface LoginCredentials {
    username: string;
    password: string;
}

export interface AuthResult {
    succeeded: string;
    errorCode: string;
    authToken: string;
    refreshToken: string;
    email: string;
    userId: string;
}

export interface AuthUser {
    id: string;
    email: string;
    role: string;
    permissions: string[];
    givenName: string;
    tenantId: string;
    employeeId?: string;
    features: string[];
}

export class User {
    private authUser: AuthUser;

    constructor(authUser: AuthUser) {
        this.authUser = authUser;
    }

    // Delegate properties to authUser
    get id() {
        return this.authUser.id;
    }
    get email() {
        return this.authUser.email;
    }
    get role() {
        return this.authUser.role;
    }
    get permissions() {
        return this.authUser.permissions;
    }
    get givenName() {
        return this.authUser.givenName;
    }
    get tenantId() {
        return this.authUser.tenantId;
    }
    get features() {
        return this.authUser.features;
    }

    // Convenience methods
    hasPermission(permission: string): boolean {
        return this.authUser.permissions.includes(permission);
    }

    hasAnyPermission(permissions: string[]): boolean {
        return permissions.some((permission) => this.authUser.permissions.includes(permission));
    }

    hasFeature(feature: string): boolean {
        return this.authUser.features.includes(feature);
    }

    hasRole(role: string): boolean {
        return this.authUser.role === role;
    }

    getAuthUser(): AuthUser {
        return this.authUser;
    }
}

export interface ChangePasswordDto {
    currentPwd: string;
    newPwd: string;
    newPwdConfirm: string;
}

export interface ChangePasswordResult {
    succeeded: boolean;
    errorMessage: string;
}

export interface AccountVerifyDto {
    userId: string;
    emailConfirmToken: string;
    passwordResetToken: string;
    password: string;
}

export interface AuthState {
    user?: AuthUser;
    showTenantSwitcher: boolean;
}

export interface ResetPasswordDto {
    userId: string;
    password: string;
    passwordResetToken?: string;
}

export interface RefreshTokenDto {
    authToken: string;
    refreshToken: string;
}
